import { flashSuccess } from '~/utils/flash'

export default (value, message) => ({
  copy() {
    navigator.clipboard.writeText(value)
    flashSuccess(message)
  },
})
